<div class="label-container">
  <span class="caption">{{ label }}</span>
  <span class="toggle-value"> {{ value }}</span>
</div>

<mat-slide-toggle
  [name]="name"
  color="primary"
  [checked]="checked"
  (change)="changeEventEmitter.emit()"
  [disabled]="disabled"
>
</mat-slide-toggle>
